import Home from "./pages/Home";
import CustomDevelopment from "./pages/CustomDevelopment";
import WebAppServices from "./pages/WebAppServices";
import MobileDevelopmentServices from "./pages/MobileDevelopmentServices";
import DevOpsServices from "./pages/DevOpsServices";
import SoftwareQualityAssurance from "./pages/SoftwareQualityAssurance";
import DataAndAnalytics from "./pages/DataAndAnalytics";
import BlockChainAnalytics from "./pages/BlockChainAnalytics";
import CyberSecurity from "./pages/CyberSecurity";
import ContactUs from "./pages/ContactUs";
import Industry from "./pages/Industry";
import LifeAtBitsclan from "./pages/LifeAtBitsclan";
import HireRubyAndRails from "./pages/HireRubyAndRails";
import HireDjango from "./pages/HireDjango";
import HirePython from "./pages/HirePython";
import HireGoLang from "./pages/HireGoLang";
import HireJavaScript from "./pages/HireJavaScript";
import HireReact from "./pages/HireReact";
import HireAngular from "./pages/HireAngular";
import HireFluter from "./pages/HireFluter";
import HireAndroid from "./pages/HireAndroid";
import HireMernStack from "./pages/HireMernStack";
import HireNode from "./pages/HireNode";
import HireContactPage from "./pages/HireContactPage";
import BlogDetails from "./pages/BlogDetails";
import Potfoliio from "./pages/Potfoliio";
import IndustryDetail from "./pages/IndustryDetail";
import NewHome from "./pages/NewHome";
import NewBlogDetails from "./pages/NewBlogDetails";
import EngagmentModel from "./pages/EngagmentModel";

import Contact from "./components/contactForm/Contact";
import UsaHome from "./pages/UsaHome";
import KsaHome from "./pages/KsaHome";
import AustraliaHome from "./pages/AustraliaHome";
import Blogs from "./pages/Blogs";
import UaeHome from "./pages/UAEHome";
import CaseStudies from "./pages/CaseStudies";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import AiMlServices from "./pages/AiMlServices";
import AiChatBotServices from "./pages/AiChatBotServices";
import AiAutomationAgency from "./pages/AiAutomationAgency";
import AIAgentDevelopment from "./pages/AIAgentDevelopment";
import LeadMaget from "./pages/LeadMaget";
import ComputerVisionDevelopmentServices from "./pages/ComputerVisionDevelopmentServices";
import GenerativeAi from "./pages/GenerativeAi";
import PageNotFound from "./pages/404page";
import IndustryDetailNew from "./pages/IndustryDetailNew";
import AIChatBotServicesNewYork from "./pages/AIChatBotServicesNewYork";
import AIChatBotServicesCalifornia from "./pages/AIChatBotServicesCalifornia";
import AIChatBotServicesTexas from "./pages/AIChatBotServicesTexas";
import AIChatBotServicesFlorida from "./pages/AIChatBotServicesFlorida";
import NewCaseStudyDetails from "./pages/NewCaseStudyDetails";
import EcommerceServices from "./pages/EcommerceServices";
import HireReactNative from "./pages/HireReactNative";
import HireMobileAIMLEngeniers from "./pages/HireMobileAIMLEngeniers";
import HireDataScientestPage from "./pages/HireDataScientestPage";
import HIreMachineLearning from "./pages/HIreMachineLearning";
import HireDevOps from "./pages/HireDevOps";
import AuraClinic from "./pages/AuraClinic";
import AuraArchitecture from "./pages/AuraArchiteture";
export const routes = [
  { path: "/", element: <UsaHome /> },
  //   { path: "/home", element: <Home /> },
  { path: "/about-us", element: <LifeAtBitsclan /> },
  // { path: "/us", element: <UsaHome /> },
  // { path: "/ksa", element: <KsaHome /> },
  // { path: "/au", element: <AustraliaHome /> },
  // { path: "/uae", element: <UaeHome /> },
  {
    path: "/ai-chatbot-development-services",
    element: <AiChatBotServices />,
  },
  {
    path: "/ai-chatbot-development-newyork",
    element: <AIChatBotServicesNewYork />,
  },
  {
    path: "/california-ai-chatbot-development-services",
    element: <AIChatBotServicesCalifornia />,
  },
  {
    path: "/ai-chatbot-development-company-texas",
    element: <AIChatBotServicesTexas />,
  },
  {
    path: "/florida-ai-chatbot-development-agency",
    element: <AIChatBotServicesFlorida />,
  },
  {
    path: "/ai-agent-development-services",
    element: <AIAgentDevelopment />,
  },
  {
    path: "/ai-ml-development-services",
    element: <AiMlServices />,
  },
  {
    path: "/ai-automation-agency",
    element: <AiAutomationAgency />,
  },
  {
    path: "/computer-vision-development-services",
    element: <ComputerVisionDevelopmentServices />,
  },
  {
    path: "/generative-ai-development-services",
    element: <GenerativeAi />,
  },
  {
    path: "/custom-software-development-services",
    element: <CustomDevelopment />,
  },
  { path: "/web-app-development-services", element: <WebAppServices /> },
  {
    path: "/mobile-app-development-services",
    element: <MobileDevelopmentServices />,
  },
  { path: "/dev-ops-services", element: <DevOpsServices /> },
  {
    path: "/quality-assurance-services",
    element: <SoftwareQualityAssurance />,
  },
  { path: "/data-analytics-services", element: <DataAndAnalytics /> },
  {
    path: "/blockchain-development-services",
    element: <BlockChainAnalytics />,
  },
  { path: "/cyber-security-services", element: <CyberSecurity /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/Industries", element: <Industry /> },
  { path: "/life-at-bitsclan", element: <LifeAtBitsclan /> },
  { path: "/hire-ruby-on-rails-developer", element: <HireRubyAndRails /> },
  { path: "/hire-data-scientists-engineers", element: <HireDataScientestPage /> },
  { path: "/hire-machine-learning-engineers", element: <HIreMachineLearning /> },
  { path: "/hire-devops-engineers", element: <HireDevOps /> },
  { path: "/hire-django-developer", element: <HireDjango /> },
  { path: "/hire-python-developers", element: <HirePython /> },
  { path: "/hire-golang-developer", element: <HireGoLang /> },
  { path: "/hire-javascript-developer", element: <HireJavaScript /> },
  { path: "/hire-react-js-developers", element: <HireReact /> },
  { path: "/hire-angular-developer", element: <HireAngular /> },
  { path: "/hire-flutter-developers", element: <HireFluter /> },
  { path: "/hire-react-native-developers", element: <HireReactNative /> },
  { path: "/hire-mobile-ai-ml-engineers", element: <HireMobileAIMLEngeniers /> },
  { path: "/hire-android-developers", element: <HireAndroid /> },
  { path: "/hire-mern-stack-developer", element: <HireMernStack /> },
  { path: "/hire-node-js-developer", element: <HireNode /> },
  { path: "/contact-us", element: <HireContactPage /> },
  { path: "/blogs/:id", element: <BlogDetails /> },
  // { path: "/case-study-details/:slug", element: <CaseStudyDetial /> },
  { path: "/case-studies/:slug", element: <NewCaseStudyDetails /> },
  { path: "/portfolio", element: <Potfoliio /> },
  // { path: "/industries/:slug", element: <IndustryDetail /> },
  { path: "/industries/:slug", element: <IndustryDetailNew /> },
  { path: "/newhome", element: <Home /> },
  { path: "/engagment-model", element: <EngagmentModel /> },
  { path: "/test", element: <Contact /> },
  { path: "/blogs", element: <Blogs /> },
  { path: "/case-studies", element: <CaseStudies /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-and-conditions", element: <TermsAndConditions /> },
  { path: "/ecommerce-services", element: <EcommerceServices /> },
  { path: "/solutions/auraclinic", element: <AuraClinic /> },
  { path: "/solutions/auraclinic/flow", element: <AuraArchitecture /> },
  {
    path: "/lead-magnet",
    element: <LeadMaget />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
